export const COCKPIT_AMPLIFY_MEMBERSHIP_ORDER = [
  'Power Elite Global',
  'Power Elite',
  'Power',
  'Power CDR',
  'Synergy',
  'Business Partner',
] as const

export const OTHER_COCKPIT_AMPLIFY_MEMBERSHIP = '__OTHER_COCKPIT_AMPLIFY_MEMBERSHIP__'
export const COCKPIT_AMPLIFY_MEMBERSHIP_OTHER_LABEL = 'Other'

export interface ICockpitAmplifyMembershipOption {
  membership: string
  label: string
}

const knownMemberships = new Set<string>(COCKPIT_AMPLIFY_MEMBERSHIP_ORDER)

export const parseCockpitAmplifyMemberships = (value?: string | null): string[] =>
  typeof value === 'string'
    ? value
        .split(',')
        .map((membership) => membership.trim())
        .filter(Boolean)
    : []

export const isKnownCockpitAmplifyMembership = (membership: string): boolean =>
  knownMemberships.has(membership)

export const getCockpitAmplifyMembershipOptions = (
  values: Array<string | null | undefined>
): ICockpitAmplifyMembershipOption[] => {
  const availableMemberships = new Set(values.flatMap(parseCockpitAmplifyMemberships))
  const options: ICockpitAmplifyMembershipOption[] = COCKPIT_AMPLIFY_MEMBERSHIP_ORDER.filter(
    (membership) => availableMemberships.has(membership)
  ).map((membership) => ({ membership, label: membership }))

  if (
    [...availableMemberships].some((membership) => !isKnownCockpitAmplifyMembership(membership))
  ) {
    options.push({
      membership: OTHER_COCKPIT_AMPLIFY_MEMBERSHIP,
      label: COCKPIT_AMPLIFY_MEMBERSHIP_OTHER_LABEL,
    })
  }

  return options
}
